import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function UseCases() {
  const {
    t
  } = useTranslation();
  const cases = [{
    labelKey: 'useCases.case0Label',
    titleKey: 'useCases.case0Title',
    descKey: 'useCases.case0Desc',
    link: 'https://map.visitbenimellal.com',
    hasLink: true
  }, {
    labelKey: 'useCases.case1Label',
    titleKey: 'useCases.case1Title',
    descKey: 'useCases.case1Desc',
    link: 'https://map.visitdraatafilalet.com',
    hasLink: true
  }, {
    labelKey: 'useCases.case2Label',
    titleKey: 'useCases.case2Title',
    descKey: 'useCases.case2Desc',
    link: '',
    hasLink: false
  }];
  return <section id="use-cases" className="py-24 bg-[#050505] relative z-20" data-id="element-300">
      <div className="max-w-7xl mx-auto px-6" data-id="element-301">
        <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-302">
          {t('useCases.sectionTitle')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-303">
          {cases.map((item, idx) => <div key={idx} className="group relative rounded-3xl overflow-hidden bg-[#0A0A0A] min-h-[400px] flex flex-col" data-id="element-304">
              <div className="absolute inset-0 border border-white/10 rounded-3xl group-hover:opacity-0 transition-opacity duration-300" data-id="element-305"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-gradient-animated rounded-3xl" data-id="element-306"></div>
              <div className="relative h-full p-10 flex flex-col z-10" data-id="element-307">
                <div className="mb-6" data-id="element-308">
                  <span className="px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider bg-white/5 text-white border border-white/10" data-id="element-309">
                    {t(item.labelKey)}
                  </span>
                </div>
                <h3 className="text-3xl font-bold mb-4 text-white" data-id="element-310">
                  {t(item.titleKey)}
                </h3>
                <p className="text-white/60 text-lg leading-relaxed flex-1" data-id="element-311">
                  {t(item.descKey)}
                </p>
                <div className="mt-6" data-id="element-312">
                  {item.hasLink ? <a href={item.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300" data-id="element-313">
                      {t('useCases.explore')}
                      <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-314" />
                    </a> : <span className="inline-flex items-center text-sm font-semibold text-white/20" data-id="element-315">
                      {t('useCases.comingSoon')}
                    </span>}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}